import React from "react";

const NotificationBellIcon = ({
  width,
  height,
  fill,
  style,
  onClick,
  notifications,
}) => {
  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <svg
        width={width}
        height={height}
        style={style}
        onClick={onClick}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.4987 14.1667H16.6654L15.4946 12.9959C15.1771 12.6784 14.9987 12.2477 14.9987 11.7987V9.16667C14.9987 6.98964 13.6074 5.13757 11.6654 4.45118V4.16667C11.6654 3.24619 10.9192 2.5 9.9987 2.5C9.07822 2.5 8.33203 3.24619 8.33203 4.16667V4.45118C6.39004 5.13757 4.9987 6.98964 4.9987 9.16667V11.7987C4.9987 12.2477 4.82032 12.6784 4.50281 12.9959L3.33203 14.1667H7.4987M12.4987 14.1667V15C12.4987 16.3807 11.3794 17.5 9.9987 17.5C8.61799 17.5 7.4987 16.3807 7.4987 15V14.1667M12.4987 14.1667H7.4987"
          stroke={fill}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {/* Notification Count */}
      {notifications > 0 && (
        <div
          style={{
            position: "absolute",
            background: "white",
            top: "-1px",
            right: "-1px",
            color: "black",
            fontSize: "8px",
            fontWeight: "700",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "10px",
            height: "10px",
            borderRadius: "50%",
          }}
        >
          {notifications > 9 ? "9+" : notifications}
        </div>
      )}
    </div>
  );
};

NotificationBellIcon.defaultProps = {
  width: 16,
  height: 18,
  fill: "white",
  notifications: 0,
};

export default NotificationBellIcon;
